export function deepParse(props) {
  if (typeof props === 'object') return props;
  const toplevelParsed = JSON.parse(props);

  return Array.isArray(toplevelParsed)
    ? toplevelParsed.map((i) => {
        const res = {};
        Object.keys(i).forEach((k) => {
          try {
            if (!k.startsWith('-')) {
              if (typeof i[k] === 'string') {
                res[k] = i[k].startsWith('{') ? JSON.parse(i[k]) : i[k];
              } else {
                res[k] = i[k];
              }
            }
            // eslint-disable-next-line no-empty
          } catch (e) {}
        });

        Object.keys(res).forEach((k) => {
          if (typeof res[k] === 'object') {
            Object.keys(res[k]).forEach((m) => {
              try {
                res[k][m] = res[k][m].startsWith('{') ? JSON.parse(res[k][m]) : res[k][m];
                // eslint-disable-next-line no-empty
              } catch (e) {}
            });
          }
        });
        return res;
      })
    : toplevelParsed;
}
